import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from './globals';
import { FileClass } from 'app/models/file-class';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from "lodash";
import { FileClassExternalOperation, FileClassExternalOperationParameter, FileClassExternalOperationParameterBindType } from 'app/models/file-class-external-operation';
import { ExternalOperationService } from './external-operation.service';
import { ConnectedAppEndpoint } from 'app/models/connected-app';

@Injectable({ providedIn: 'root' })
export class FileClassService {

    constructor(private http: HttpClient, private globals: Globals,
                private formBuilder: FormBuilder, private externalOperationService: ExternalOperationService) {
    }

    list() {
        return this.http.get<FileClass[]>(`${this.globals.api_base_url}/file_classes`);
    }

    put(fileClass: FileClass) {
        return this.http.put<FileClass>(`${this.globals.api_base_url}/file_class`, fileClass);
    }

    deleteById(id: number) {
        return this.http.delete(`${this.globals.api_base_url}/file_class/${id}`);
    }

    formGroup(fileClass: FileClass = null) {
        let frmGrp: FormGroup = this.formBuilder.group({
            id: [(fileClass)? fileClass.id: null],
            name: [(fileClass)? fileClass.name: '', [Validators.required, Validators.maxLength(255)]],
            extension: [(fileClass)? fileClass.extension: '', []],
            is_ocr: [(fileClass)? fileClass.is_ocr: false],
            required_metadata: [(fileClass)? fileClass.required_metadata: []],
            optional_metadata: [(fileClass)? fileClass.optional_metadata: []],
            external_operations: [(fileClass)? fileClass.external_operations: []]
        });
        return frmGrp;
    }

    externalOperationFormGroup(fileClassExternalOperation: FileClassExternalOperation = null) {
        let frmGrp: FormGroup = this.formBuilder.group({
            id: [(fileClassExternalOperation)? fileClassExternalOperation.id: null],
            parameters: this.externalOperationParametersFormArray((fileClassExternalOperation? (fileClassExternalOperation.parameters || []): [])),
            external_operation_common_settings: this.externalOperationService.externalOperationCommonSettingsFormGroup((fileClassExternalOperation)? fileClassExternalOperation.external_operation_common_settings: null)
        });        
        return frmGrp;
    }

    updateExternalOperationParametersFromEndpoint(formGroup: FormGroup, endpoint: ConnectedAppEndpoint) {
        let newParameters: FileClassExternalOperationParameter[] = [];
        if (endpoint) {
            let newEndpoint: ConnectedAppEndpoint = <ConnectedAppEndpoint>endpoint;
            (newEndpoint.parameters || []).forEach((p) => {
                newParameters.push(<FileClassExternalOperationParameter>{
                    connected_app_parameter: p,
                    connected_app_parameter_id: p.id
                });
            });
        }
        let newParametersFormArray = this.externalOperationParametersFormArray(newParameters);
        formGroup.controls['parameters'] = newParametersFormArray;
        newParametersFormArray.setParent(formGroup);        
    }

    externalOperationParametersFormArray(parameters: FileClassExternalOperationParameter[]) {
        let parametersFormArray = this.formBuilder.array([]);
        parameters.forEach((p) => {
            parametersFormArray.push(this.formBuilder.group({
                id: [p.id],
                bind_type: [p.bind_type || ((p.connected_app_parameter.default_value)? FileClassExternalOperationParameterBindType.CONSTANT_VALUE: FileClassExternalOperationParameterBindType.METADATA), Validators.required],
                constant_value: [p.constant_value || p.connected_app_parameter.default_value, [(c: AbstractControl) => { return (c.parent && c.parent.get('bind_type').value == FileClassExternalOperationParameterBindType.CONSTANT_VALUE)? Validators.required(c): null}]],
                script: [p.script, [(c: AbstractControl) => { return (c.parent && c.parent.get('bind_type').value == FileClassExternalOperationParameterBindType.SCRIPT)? Validators.required(c): null}]],
                central_metadata_id: [p.central_metadata_id, [(c: AbstractControl) => { return (c.parent && c.parent.get('bind_type').value == FileClassExternalOperationParameterBindType.METADATA)? Validators.required(c): null}]],
                connected_app_parameter: [p.connected_app_parameter, Validators.required],
                connected_app_parameter_id: [p.connected_app_parameter_id, Validators.required]
            }));
        });

        return parametersFormArray;
    }

    formFromFileClass(fileClass: FileClass) {
        let form: { components: any[] } = { components: [] }

        if (fileClass && fileClass.name == '') {
            return form;
        }

        if (fileClass) {
            (fileClass.required_metadata || []).forEach((m) => {
                form.components.push(_.merge(_.cloneDeep(m.schema), { validate: { required: true }}));
            });

            (fileClass.optional_metadata || []).forEach((m) => {
                form.components.push(_.merge(_.cloneDeep(m.schema), { validate: { required: false }}));
            });
        }

        return form;
    }
}